export default __webpack_public_path__ + "static/media/ILPlatform_Programme8-11.cc4c66cb.webp";